module.exports = __webpack_public_path__ + "img/team-3.d4351fc2.jpg";